import * as actions from './tax-details.actions';
import { DatesInterval, FinancialYearDatesInterval, SortInfo } from '../../global/interfaces';
import { TaxDetailsDataResponse } from './tax-details.models';

export interface State {
    loading: boolean;
    dates?: DatesInterval;
    financialYearDate?: FinancialYearDatesInterval;
    data: TaxDetailsDataResponse;
    filter?: any;
    sort: SortInfo;

}

export const initialState: State = {
    loading: false,
    dates: undefined,
    data: {
        taxDetailsData: [],
        taxDetailsDate: undefined,
        total: undefined,
        pir: undefined
    },
    financialYearDate: undefined,
    filter: {
        year: undefined,
        month: undefined
    },
    sort: {
        column: 'name',
        reverse: true
    }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.ActionTypes.LOAD_TAX_DETAILS_DATES:
            return {
                ...state,
                loading: true,
                dates: undefined,
                financialYearDate: undefined,
                filter: { ...state.filter, month: undefined, year: undefined, date: undefined }
            };
        case actions.ActionTypes.LOAD_TAX_DETAILS_DATES_SUCCESS:
            return { ...state, loading: false, dates: action.payload };
        case actions.ActionTypes.LOAD_TAX_DETAILS_DATES_FAILED:
            return { ...state, loading: false };
        case actions.ActionTypes.LOAD_TAX_DETAILS:
            return { ...state, loading: true, data: initialState.data };
        case actions.ActionTypes.LOAD_TAX_DETAILS_SUCCESS:
            return {
                ...state, loading: false, data: {
                    taxDetailsDate: action.payload.taxDetailsDate,
                    taxDetailsData: action.payload.taxDetailsData,
                    total: action.payload.total,
                    pir: action.payload.pir
                }
            };
        case actions.ActionTypes.LOAD_TAX_DETAILS_FAILED:
            return { ...state, loading: false, data: initialState.data };
        case actions.ActionTypes.SET_TAX_DETAILS_YEAR_FILTER:
            return { ...state, filter: { ...state.filter, year: action.payload } };
        case actions.ActionTypes.SET_TAX_DETAILS_DATE_FILTER:
            return { ...state, filter: { ...state.filter, date: action.payload } };
        case actions.ActionTypes.SET_TAX_DETAILS_MONTH_FILTER:
            return { ...state, filter: { ...state.filter, month: action.payload } };
        case actions.ActionTypes.SET_TAX_DETAILS_START_END_FINANCIAL_YEAR:
            return { ...state, loading: false, financialYearDate: action.payload };
        case actions.ActionTypes.RESET_TAX_DETAILS_DATA:
            return initialState;
        default:
            return state;
    }
}
